import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const answerServiceApi = createApi({
  reducerPath: 'answerServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['Answer'],
  endpoints: (builder) => ({
    // Fetch all answers for a question
    getAnswersByQuestionId: builder.query({
      query: (questionId) => `/backoffice/questions/${questionId}/answers`,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Answer', id })),
              { type: 'Answer', id: 'LIST' },
            ]
          : [{ type: 'Answer', id: 'LIST' }],
    }),
    // Add a new answer
    addAnswer: builder.mutation({
      query: (newAnswer) => ({
        url: '/backoffice/answers/save',
        method: 'POST',
        body: newAnswer,
      }),
      invalidatesTags: [{ type: 'Answer', id: 'LIST' }],
    }),
    // Update an answer
    updateAnswer: builder.mutation({
      query: ({ id, ...updateData }) => ({
        url: `/backoffice/answers/update/${id}`,
        method: 'PUT',
        body: updateData.formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Answer', id },
        { type: 'Answer', id: 'LIST' },
      ],
    }),
    // Delete an answer
    deleteAnswer: builder.mutation({
      query: (id) => ({
        url: `/backoffice/answers/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Answer', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetAnswersByQuestionIdQuery,
  useAddAnswerMutation,
  useUpdateAnswerMutation,
  useDeleteAnswerMutation,
} = answerServiceApi
